import { Outlet, createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_auth/sso')({
  staticData: {
    pageName: 'SSO',
  },
  component: () => <Outlet />,
});
